// Homepage client logo strip (components/about/ClientLogos.tsx). The company
// names, roles, dates and logo paths are not translated; they live in
// src/data/clients.ts.
//
// "Worked with" rather than "Trusted by": these are universities, an alliance
// and studios he was an engineer for, and the plainer phrasing claims exactly
// that. /references carries the roles and dates.
const clients = {
  label: 'Worked with',
};

export default clients;
